import api from '../api'
import axios from '../axios'

class HomeService {
  /**
   * 首页设置
   */
  static getHomeSetting () {
    return axios.get(api.reserve.home).then(res => {
      if (res.data && res.data.code === 1) {
        const banner = res.data.data.banner
        const pcbanner = res.data.data.pc_banner
        const wechat_share = res.data.data.wechat_share
        const products = res.data.data.reserve.map((item) => {
          return item.product
        })
        const special = res.data.data.special.map((item) => {
          return item.product
        })
        const statistics = res.data.data.statistics
        return Promise.resolve({ banner, products, special, statistics, wechat_share, pcbanner })
      }
      return Promise.reject(new Error('Server Error'))
    })
  }
}

export default HomeService
